import { render, staticRenderFns } from "./OcrList.vue?vue&type=template&id=53e81020"
import script from "./OcrList.vue?vue&type=script&lang=js"
export * from "./OcrList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports